var postBodySizeData = function(url){
  const ajaxLoadUrlFetchAbortController = new AbortController();
  return fetch(url, {
    method: 'GET',
    headers: {
      // 'X-Requested-With': 'XMLHttpRequest',
      "accept": "application/json, text/plain, */*",
    },
    cache: 'force-cache',
    signal: ajaxLoadUrlFetchAbortController.signal
  }).then(function(response){
    return response.text();
  }).then(function(text){
    var responseHTML = new DOMParser().parseFromString(text, 'text/html');
    return { data: responseHTML };
  });
}
class ProductSize extends HTMLElement {
   constructor() {
    super();
    this.index = 0;
  }
  connectedCallback() {
    this.init();
    this.getBodySize();
  }
  init(){
    this.querySelectorAll('.size-tab span').forEach((item,index)=>{
      if(item.classList.contains('link')){
           item.onclick = ()=>{
            if(this.index == index) return;
            let type = item.getAttribute('data-type')
            this.querySelector(`.${type}-tabel`).style.display = 'block';
            type == 'body' ? this.querySelector('.product-tabel').style.display = 'none' : this.querySelector('.body-tabel').style.display = 'none';
            item.classList.add('is-active');
            this.querySelectorAll('.size-tab span')[this.index].classList.remove('border-bottom');
            this.querySelectorAll('.size-tab span')[this.index].classList.remove('is-active');
            item.classList.add('border-bottom')
            // this.querySelector('.size-tab span.border').style.transform = `translate3d(${item.offsetLeft}px,0,0)`;
            // this.querySelector('.size-tab span.border').style.width = `${item.offsetWidth}px`;
            // if(!this.querySelector('.size-tab span.border').style.display) this.querySelector('.size-tab span.border').style.display = 'block';
            this.index = index;
            this.setAttribute('data-type',item.innerText);
          }
      }
    })
    this.querySelectorAll('.size-option label').forEach((item)=>{
      item.onclick = ()=>{
        this.setAttribute('data-tabel-type',item.innerText);
      }
    })
  }
  changeTable(){
    setTimeout(()=>{
      this.querySelectorAll('td').forEach((item)=>{
        item.onmouseenter = (e)=>{
          e.target.classList.add('td-enter');
          let Parent = e.target.offsetParent;
          let top = e.target.offsetTop;
          let left = e.target.offsetLeft;
          let parentElement = e.target.parentElement;
          Parent.querySelectorAll('thead th') &&  Parent.querySelectorAll('thead th')[e.target.cellIndex].classList.add('td-enter')
          Parent.querySelectorAll('td').forEach((item,index)=>{
            if(!item.classList.contains('td-enter') && e.target.cellIndex == item.cellIndex && top > item.offsetTop){
              item.classList.add('td-same-col')
            }
          })
          parentElement.querySelectorAll('td').forEach((item,index)=>{
            if(index == 0) item.classList.add('td-enter')
            if(!item.classList.contains('td-enter') && left > item.offsetLeft){
              item.classList.add('td-same-col')
            }
          })
        }
        item.onmouseleave = (e)=>{
          e.target.classList.remove('td-enter');
          let Parent = e.target.offsetParent;
          let top = e.target.offsetTop;
          let left = e.target.offsetLeft;
          let parentElement = e.target.parentElement;
          Parent.querySelectorAll('thead th') &&  Parent.querySelectorAll('thead th')[e.target.cellIndex].classList.remove('td-enter')
          Parent.querySelectorAll('td').forEach((item,index)=>{
            if(!item.classList.contains('td-enter') && e.target.cellIndex == item.cellIndex && top > item.offsetTop){
              item.classList.remove('td-same-col')
            }
          })
          parentElement.querySelectorAll('td').forEach((item,index)=>{
            if(index == 0) item.classList.remove('td-enter')
            if(!item.classList.contains('td-enter') && left > item.offsetLeft){
              item.classList.remove('td-same-col')
            }
          })
        }
      })
    },1500)
  }
  getBodySize(){
    if(this.dataset.productType == "WOMEN"){
      let url = this.dataset.bodyType == 'top' ? '/pages/womans-body-tops-size' : '/pages/womans-body-bottoms-size' 
      postBodySizeData(url).then((res)=>{
        this.querySelector('.body-tabel .tabel-wrapper').innerHTML = res.data.querySelector('.rte').innerHTML;
      })
      let change = this.dataset.bodyType == 'top' ? '/pages/womens-top-product-measuring-guide' : '/pages/womens-bottoms-product-measuring-guide'
      if(change){
        postBodySizeData(change).then((res)=>{
          this.querySelector('.product-tabel .size-icon-wrapper').innerHTML = res.data.querySelector('.rte').innerHTML;
        })
      }
      let body = this.dataset.bodyType == 'top' ? '/pages/womens-tops-body-measuring-guide' : '/pages/womens-bottoms-body-measuring-guide'
      if(body){
        postBodySizeData(body).then((res)=>{
          this.querySelector('.body-tabel .body-icon').innerHTML = res.data.querySelector('.rte').innerHTML;
        })
      }
      this.changeTable();
      return;
    }
    let url = this.dataset.bodyType == 'top' ? '/pages/body-tops-size' : this.dataset.bodyType == 'bottom' ? '/pages/body-bottoms-size'  : '/pages/body-guide-bottoms-size'
    postBodySizeData(url).then((res)=>{
      this.querySelector('.body-tabel .tabel-wrapper').innerHTML = res.data.querySelector('.rte').innerHTML;
    })
    let change = this.dataset.bodyType == 'top' ? '/pages/mens-top-product-measuring-guide' : '/pages/mens-bottoms-product-measuring-guide'
    if(change){
      postBodySizeData(change).then((res)=>{
        this.querySelector('.product-tabel .size-icon-wrapper').innerHTML = res.data.querySelector('.rte').innerHTML;
      })
    }
    let body = this.dataset.bodyType == 'top' ? '/pages/mens-tops-body-measuring-guide' : '/pages/mens-bottoms-body-measuring-guide'
      if(body){
        postBodySizeData(body).then((res)=>{
          this.querySelector('.body-tabel .body-icon').innerHTML = res.data.querySelector('.rte').innerHTML;
        })
      }
    this.changeTable();
  }
}
customElements.define('product-size', ProductSize);